import { ReactNode } from "react";

interface FormatButtonProps {
  label: string;
  active?: boolean;
  onTrigger: () => void;
  children: ReactNode;
}

function FormatButton({ label, active, onTrigger, children }: FormatButtonProps) {
  return (
    <div className="group relative">
      <button
        type="button"
        aria-label={label}
        onMouseDown={e => {
          e.preventDefault();
          onTrigger();
        }}
        className={`w-7 h-7 border rounded flex items-center justify-center select-none ${active
          ? "bg-gray-200 border-gray-400 text-gray-900"
          : "bg-white border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400"
          }`}
      >
        {children}
      </button>
      <span className="tooltip bottom-full mb-1.5 left-1/2 -translate-x-1/2">
        {label}
      </span>
    </div>
  );
}

export default FormatButton;
